(function () {
  'use strict';
  if (window.usaOrderSourceTracking) return;
  window.usaOrderSourceTracking = true;
  const property = '_USA recommendation';
  const sources = {
    finder:'Help Choosing', last:'Last Chance', best:'Best Sellers', hero:'Homepage Hero',
    related:'You may also like', picked:'Picked for you', recent:'Recently Viewed',
    search:'Search', collection:'Collection', tracking:'Tracking Discover',
    promo:'Homepage Promotion', product:'Product Page', home:'Homepage Products',
    hp_best:'Homepage Bestsellers', hp_last:'Homepage Last Chance', hp_new:'Homepage Just In',
    hp_sets:'Homepage Sets', hp_cats:'Homepage Categories', hp_journal:'Homepage Journal', menu:'Menu'
  };
  // Section that led to the current page (e.g. homepage hero -> collection). Travels in the link fragment only.
  const viaProperty = '_USA via';
  const selectors = [
    ['#ohp-bestsellers','hp_best'], ['#ohp-last-chance','hp_last'], ['#ohp-just-in','hp_new'], ['#ohp-sets','hp_sets'],
    ['.ohp-hero','hero'], ['.ohp-cats,.ohp-cats-head','hp_cats'], ['.ohp-journal','hp_journal'],
    ['#acne-finder,.usa-skin-quiz,.ohp-quiz','finder'], ['.cart__recommendations,#usa-recommendations,.section-related-products,product-recommendations','related'],
    ['.usa-last','last'], ['.usa-best-sellers','best'], ['.usa-campaign-hero','hero'],
    ['#usa-picked-for-you','picked'], ['.usa-recent,[id*="usa-recent"],.recently-viewed,.section-recently-viewed','recent'],
    ['.usa-search-discovery,predictive-search,.predictive-search,search-modal','search'],
    ['.yq-app','tracking'], ['.usa-promos,.usa-promo','promo'],
    ['#menu-drawer,.menu-drawer,.mega-menu,.header__inline-menu','menu']
  ];
  function pageSource() {
    const path=location.pathname;
    if(/\/collections\/last-chance(?:\/|$)/.test(path))return 'last';
    if(/\/collections\/best-sellers(?:\/|$)/.test(path))return 'best';
    if(/\/collections\//.test(path))return 'collection';
    if(/\/search(?:\/|$)|\/pages\/a-search(?:\/|$)/.test(path))return 'search';
    if(path==='/'||/^\/[a-z]{2}(?:-[a-z]{2})?\/?$/.test(path))return 'home';
    return '';
  }
  function contextSource(element, includePage=true) {
    if(!element?.closest)return '';
    for(const [selector,key] of selectors)if(element.closest(selector))return key;
    return includePage?pageSource():'';
  }
  function fragmentSource(hash, name='usa-rec') {
    const key=new URLSearchParams(hash.replace(/^#/, '')).get(name);
    return sources[key]?key:'';
  }
  // Read once on load so filters/pagination that rewrite the URL don't lose it.
  const pageVia=fragmentSource(location.hash,'usa-via');
  function markLink(event) {
    const link=event.target.closest?.('a[href]');if(!link)return;
    let url;try{url=new URL(link.href,location.href);}catch(_){return;}
    if(url.origin!==location.origin)return;
    if(!url.pathname.includes('/products/')){
      // A tracked section leading to a collection/search page: remember it for that page's product links.
      if(!/\/(collections|search)(\/|$)/.test(url.pathname)||url.hash)return;
      const from=contextSource(link,false);if(!from)return;
      url.hash='usa-via='+from;link.href=url.href;return;
    }
    const key=contextSource(link);if(!key)return;
    // The source travels with this product link only; no browsing-history storage.
    const frag=new URLSearchParams();frag.set('usa-rec',key);
    const via=pageSource()&&!contextSource(link,false)?pageVia:'';
    if(via&&via!==key)frag.set('usa-via',via);
    url.hash=frag.toString();link.href=url.href;
  }
  ['pointerdown','click','auxclick'].forEach(name=>document.addEventListener(name,markLink,true));
  function sourceFor(form) {
    if(!form?.matches('form[action*="/cart/add"]'))return '';
    const context=contextSource(form,false);if(context)return context;
    if(form.closest('[id^="MainProduct-"],.section-featured-product'))return fragmentSource(location.hash)||'product';
    return pageSource();
  }
  function viaFor(form, key) {
    let via='';
    if(form.closest('[id^="MainProduct-"],.section-featured-product')&&!contextSource(form,false))via=fragmentSource(location.hash,'usa-via');
    else if(!contextSource(form,false))via=pageVia;
    return via&&via!==key?via:'';
  }
  function annotate(form) {
    const key=sourceFor(form);if(!key)return;
    let input=form.querySelector('[data-usa-order-source]')||form.querySelector('input[name="properties[_USA recommendation]"]');
    if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+property+']';form.append(input);}
    input.dataset.usaOrderSource='true';input.value=sources[key];
    const via=viaFor(form,key);
    let viaInput=form.querySelector('[data-usa-order-via]');
    if(via){if(!viaInput){viaInput=document.createElement('input');viaInput.type='hidden';viaInput.name='properties['+viaProperty+']';viaInput.dataset.usaOrderVia='true';form.append(viaInput);}viaInput.value=sources[via];}
    else if(viaInput)viaInput.remove();
  }
  function annotateForms(){document.querySelectorAll('form[action*="/cart/add"]').forEach(annotate);}
  document.addEventListener('submit',event=>{if(event.target instanceof HTMLFormElement)annotate(event.target);},true);
  // Captures AJAX quick-add and sticky-cart FormData without changing requests or checkout.
  document.addEventListener('formdata',event=>{const key=sourceFor(event.target);if(!key)return;event.formData.set('properties['+property+']',sources[key]);const via=viaFor(event.target,key);if(via)event.formData.set('properties['+viaProperty+']',sources[via]);else event.formData.delete('properties['+viaProperty+']');},true);
  window.addEventListener('hashchange',annotateForms);
  document.addEventListener('shopify:section:load',annotateForms);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',annotateForms,{once:true});else annotateForms();
})();
